import script from "./AAmostraDeCor.vue?vue&type=script&lang=ts&setup=true"
export * from "./AAmostraDeCor.vue?vue&type=script&lang=ts&setup=true"

import "./AAmostraDeCor.vue?vue&type=style&index=0&id=53ff2d23&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53ff2d23"]])

export default __exports__